<template>
  <span
    class="d-block"
    style="direction: ltr"
  >
    {{ displayValue }}
  </span>
</template>

<script>
import { localeDate, localeDateTime } from '../../common/utils/utils'

export default {
  name: 'DisplayDateTime',
  props: {
    type: {
      type: String,
      default: () => 'datetime',
    },
    value: {
      type: String,
      default: () => '',
    },
  },
  computed: {
    displayValue() {
      return this.type === 'datetime' ? localeDateTime(this.value) : localeDate(this.value)
    },
  },
}
</script>

<style scoped>

</style>
